import React from 'react';
import {
  RoamingContainerSkeletonStyled,
  RoamingContainerStyled,
  SkeletonStyled,
} from './styles/RoamingSkeletonStyled';

const RoamingSkeleton = () => {
  return (
    <RoamingContainerStyled data-testid="roaming-skeleton">
      <RoamingContainerSkeletonStyled>
        <SkeletonStyled />
        <SkeletonStyled />
      </RoamingContainerSkeletonStyled>
      <RoamingContainerSkeletonStyled>
        <SkeletonStyled />
        <SkeletonStyled />
      </RoamingContainerSkeletonStyled>
      <RoamingContainerSkeletonStyled>
        <SkeletonStyled />
        <RoamingContainerSkeletonStyled>
          <SkeletonStyled />
          <SkeletonStyled />
        </RoamingContainerSkeletonStyled>
        <RoamingContainerSkeletonStyled>
          <SkeletonStyled />
        </RoamingContainerSkeletonStyled>
      </RoamingContainerSkeletonStyled>
    </RoamingContainerStyled>
  );
};

export default RoamingSkeleton;
